<script>
	import { Dialog as DialogPrimitive } from 'bits-ui';
	import { cn } from '$lib/utils.js';
	let className = undefined;
	export { className as class };
	import Plyr from 'plyr';
	import { onMount } from 'svelte';
	onMount(() => {
		Array.from(document.querySelectorAll('.js-player')).map(
			(p) =>
				new Plyr(p, { controls: ['play-large', 'play', 'progress', 'current-time', 'duration'] })
		);
		Array.from(document.querySelectorAll('.player')).map(
			(p) =>
				new Plyr(p, { controls: ['play-large', 'play', 'progress', 'current-time', 'duration'] })
		);
	});
</script>

<DialogPrimitive.Description
	class={cn('text-sm text-muted-foreground', className)}
	{...$$restProps}
>
	<slot />
</DialogPrimitive.Description>
